import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminReportsPage from '../../../subsreens/gcadmin/adminreports/AdminReportsPage';


const GenerateReports = () => {
    return(
       <AdminMasterLayout>
        <AdminReportsPage></AdminReportsPage>
       </AdminMasterLayout>
    )
}

export default GenerateReports;